// extracted by mini-css-extract-plugin
export default {"container":"reg_3sRnw"};